<template>
  <div class="share-page-container">
    <!-- 单层滚动容器：头部+内容 整体滚动 -->
    <div class="scroll-wrap" ref="scrollWrap">
      <!-- 顶部标题栏 -->
      <div class="share-header">
        <h2>来自分享的对话</h2>
        <p class="tip" v-if="titleObj?.created_at">
          {{ titleObj.created_at.slice(0, 10) }} <span class="tip_span"> 内容由 AI 生成，请注意核实</span>
        </p>
      </div>

      <!-- 内容区域 -->
      <div class="share-content" v-loading="loading">
        <div v-if="errorMsg" class="empty-box error">
          {{ errorMsg }}
        </div>
        <div v-else-if="list.length === 0" class="empty-box">
          暂无分享内容
        </div>
        <div v-else class="message-box" v-for="(item, index) in list" :key="index">
          <div class="message-item user">
            <div class="message-content user-content">
              <div class="upload-info messageView" v-if="item.message_files?.length > 0">
                <div class="upload-item_file" v-for="(file, idx) in item.message_files" :key="idx">
                  <div class="upload-preview" v-if="file.type === 'image'">
                    <img :src="file.url" @click="previewImage(file.url)">
                  </div>
                  <div class="upload-details down" v-else>
                    <div class="upload-name">{{ file.filename }}</div>
                    <div class="downView">
                      <i class="el-icon-download" style="cursor: pointer;color: #999"
                        @click.stop="handleShareFileTip"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="markdown-body" v-html="formatMessage(item.query)"></div>
            </div>
          </div>
          <div class="message-item assistant">
            <div class="message-content assistant-content">
              <div class="markdown-body" v-html="formatMessage(item.answer)" @click.capture="stopLink($event)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部固定按钮 -->
    <div class="fixed-btn-box" v-if="!errorMsg">
      <button class="back-home-btn" @click="goHome">继续和碳知对话 <i class="el-icon-right"></i></button>
    </div>

    <div class="footer-tip" ref="footerTip" :class="{ show: showFooterTip }">
      <span class="text-fix">碳知</span><span class="dian-fix">·</span>助力为每一克碳排放发现更优解
    </div>
  </div>
</template>

<script>
window.openExcelViewer = () => {};
window.openQuestionNaire = () => {};
import { formatChatMessage } from "@/utils/formatChatMarkdown";
import { getShareCode } from '@/api'

export default {
  name: 'SharePage',
  data() {
    return {
      loading: true,
      list: [],
      shareCode: '',
      accessType: 'tz',
      titleObj: {},
      errorMsg: '',
      showFooterTip: false
    }
  },
  mounted() {
    this.shareCode = this.$route.params.shareCode
    this.getShareData().then(() => {
      this.$nextTick(() => {
        this.initScrollListener()
      })
    })
  },
  beforeDestroy() {
    if (this.$refs.scrollWrap) {
      this.$refs.scrollWrap.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    formatMessage(text) {
      return formatChatMessage(text, this.accessType)
    },

    initScrollListener() {
      const scrollWrap = this.$refs.scrollWrap
      if (!scrollWrap) return
      scrollWrap.addEventListener('scroll', this.handleScroll)
    },

    handleScroll() {
      const scrollWrap = this.$refs.scrollWrap
      const { scrollTop, scrollHeight, clientHeight } = scrollWrap
      // 滚动到底部时触发（提前 50px 显示更自然）
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 50
      this.showFooterTip = isAtBottom
    },

    async getShareData() {
      this.errorMsg = '';
      try {
        const res = await getShareCode(this.shareCode);
        console.log(res.data.code)
        if (res.data.code !== 200) {
          this.errorMsg = res.data.data
          this.list = [];
          this.titleObj = {};
          return;
        }
        this.list = res.data.data?.data || [];
        this.titleObj = res.data.data?.conversation || {};
      } catch (err) {
        console.error('获取分享内容失败', err);
        console.log(err,'err')
        this.errorMsg = err?.response?.data?.msg || '分享链接无效或已过期，请检查链接或重新获取';
        this.list = [];
        this.titleObj = {};
      } finally {
        this.loading = false;
        this.$nextTick(() => {
          this.handleScroll(); // 初始化就判断一次是否到底
        });
      }
    },

    goHome() {
      this.$router.push({ name: 'WecomePage' })
    },

    stopLink(e) {
      const target = e.target;

      if (target.hasAttribute('onclick')) {
        e.preventDefault();
        e.stopPropagation();
        this.$message.warning('完整功能请前往碳知使用');
        return;
      }

      if (target.tagName === 'A') {
        const href = target.getAttribute('href');
        const text = target.innerText.trim();
        e.preventDefault();
        e.stopPropagation();

        if (text.includes('AI碳盘查服务') || text.includes('AI碳足迹服务')) {
          this.$message.warning('完整功能请前往碳知使用');
          return;
        }

        if (href.includes('/ai_open_file/') || text.includes('数据收集表')) {
          this.$message.warning('完整功能请前往碳知使用');
          return;
        }

        if (href.includes('/downloadFile/')) {
          window.open(href, '_blank');
          return;
        }
        window.open(href, '_blank');
      }
    },

    previewImage(imageUrl) {
      const previewOverlay = document.createElement("div");
      previewOverlay.style.cssText = `
        position: fixed; top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(0,0,0,0.8); display: flex; justify-content: center;
        align-items: center; z-index: 9999; cursor: pointer;
      `;
      const img = new Image();
      img.src = imageUrl;
      img.style.cssText = "max-width:90%; max-height:90%; border-radius:8px";
      previewOverlay.appendChild(img);
      previewOverlay.onclick = () => document.body.removeChild(previewOverlay);
      document.body.appendChild(previewOverlay);
    },

    handleShareFileTip() {
      this.$message.warning("无法查看或下载共享对话中的文件");
    }
  }
}
</script>

<style>
@import "../assets/styles/index.css";
</style>

<style scoped>
.share-page-container {
  width: 100%;
  height: 100vh;
  background: #f7f8fa url(../assets/images/bg.svg) no-repeat center center;
  background-size: cover;
  overflow: hidden;
  position: relative;
}

/* 唯一滚动容器 */
.scroll-wrap {
  max-width: 1220px;
  margin: 0 auto;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  /* 底部留白，避开固定按钮 */
  padding-bottom: 180px;

  /* 隐藏滚动条 */
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scroll-wrap::-webkit-scrollbar {
  display: none;
}


.share-header {
  margin-top: 20px;
  padding: 30px 36px 20px;
  background: #fff;
  border-radius: 8px 8px 0 0;
  position: sticky;
  top: 0;
  z-index: 10;
}

.share-header::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  /* 这里改数值控制线条长短，比如 60% / 50% / 300px */
  width: 94%;
  height: 1px;
  background: #eee;
}

.share-header h2 {
  font-size: 20px;
  margin: 0;
  font-weight: 500;
}

.share-header .tip {
  font-size: 13px;
  color: #999;
  margin: 6px 0 0;
}

.tip_span {
  margin-left: 6px;
}

.share-content {
  padding: 20px 36px;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
}

.message-box {
  margin-bottom: 30px;
}

.message-item {
  margin-bottom: 16px;
  display: flex;
}

.message-item.user {
  justify-content: flex-end;
}

.user-content {
  background: rgba(234, 242, 248, 1);
  color: rgba(33, 33, 33, 1);
  padding: 12px 16px;
  border-radius: 18px 18px 4px 18px;
  max-width: 75%;
}

.message-item.assistant {
  justify-content: flex-start;
}

.assistant-content {
  background: #fff;
  color: #333;
  padding: 12px 16px;
  border-radius: 18px 18px 18px 4px;
  max-width: 100%;
  width: 100%;
  /* border: 1px solid #eee; */
}

.markdown-body {
  line-height: 1.6;
  word-break: break-all;
}

.markdown-body p {
  margin: 0 0 8px 0;
}

.markdown-body a {
  color: #0066ff;
  text-decoration: underline;
}

.empty-box {
  text-align: center;
  padding: 60px 20px;
  color: #999;
  font-size: 14px;
}

::v-deep .excel-view-btn {
  background: var(--global-primary);
  color: white;
  border: none;
  border-radius: 5px;
  padding: 6px 12px;
  cursor: pointer;
  line-height: 120%;
  font-size: 16px;
  transition: background-color 0.2s;
  outline: none;
  margin: 6px 6px;
}

::v-deep .span-link {
  color: #1a73e8;
  cursor: pointer;
  text-decoration: underline;
}

.fixed-btn-box {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 60px;
  text-align: center;
  z-index: 99;
}

.back-home-btn {
  padding: 9px 32px;
  background: #0066ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 18px;
  cursor: pointer;
}

.back-home-btn:hover {
  background: #0052d9;
}

.upload-info.messageView {
  margin-bottom: 8px;
  width: 100%;
}

.upload-item_file {
  margin-bottom: 6px;
  border-radius: 8px;
  overflow: hidden;
  max-width: 280px;
}

.upload-preview img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 200px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
}

.upload-details.down {
  display: flex;
  
  /* align-items: center; */
  justify-content: space-between;
  padding: 0 12px;
  /* background: #f5f7fa; */
  border-radius: 8px;
  font-size: 14px;
}

.upload-name {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.downView {
  cursor: pointer;
  color: #409eff;
  font-size: 16px;
}

.downView i {
  vertical-align: middle;
}

.footer-tip {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 20px;
  text-align: center;
  color: #999;
  font-size: 16px;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none; /* 不影响点击 */
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-fix {
  font-weight: 600;
}

.dian-fix {
  font-size: 22px;
  margin: 0 2px;
}

.footer-tip.show {
  opacity: 1;
}
</style>